<template>
  <div class="p-4">
    <button @click="createNewShipper" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Shippers
    </button>
    <el-table
      style="width: 100%"
      :default-sort="{ prop: 'id', order: 'ascending' }"
      :data="shippersList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))">
      <el-table-column prop="name" label="Shipper's Name" sortable> </el-table-column>
      <el-table-column prop="address" label="Address" sortable> </el-table-column>
      <el-table-column prop="phone" label="Phone Number" sortable> </el-table-column>
      <el-table-column prop="status" label="Is Active" sortable="">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status"></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header">
          <el-input v-model="search" size="mini" placeholder="Type to search" />
        </template>
        <template slot-scope="scope">
          <el-button @click="editShipperDetails(scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit mr-4"></i>
          </el-button>
          <el-button @click="deleteShipper(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <UpdateForm />
    <ShipperCreationForm />
  </div>
</template>

<script>
import ShipperCreationForm from './_includes/CreateShipper.vue';
import UpdateForm from './_includes/UpdateForm.vue';

export default {
  name: 'Shippers',
  components: {
    ShipperCreationForm,
    UpdateForm,
  },
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
    };
  },
  computed: {
    shippersList() {
      return this.$store.state.InventoryModule.Shippers.shippers;
    },
    pagination() {
      return this.$store.state.InventoryModule.Shippers.pagination;
    },
  },
  methods: {
    createNewShipper() {
      this.$modal.show('new-shipper');
    },
    editShipperDetails(shipper) {
      this.$modal.show('update-shipper', { shipper });
    },
    deleteShipper(shipperId) {
      this.$confirm('Are you sure you want to delete this Shipper?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Shippers/deleteShippers', { shipperId });
          this.$notify.success({
            title: 'Success',
            message: 'Shipper has been successfully deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'An error occurred. Please try again.',
          });
        }
      });
    },
    getShippers() {
      try {
        this.$store.dispatch('InventoryModule/Shippers/fetchAllShippers');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
};
</script>
